var IpcDataModel = require("./index.js");
var UnitConversions = require("cio-config").UnitConversions;

var IpcPackageParamHelper = {};

IpcPackageParamHelper.getBodyColor = function(data) {
    var hex;
    var color = {
        r: 10,
        g: 10,
        b: 10
    };

    function convertColor(hex) {
        hex = hex.replace(/^#/,'');
        var length = hex.length;
        if (length == 3){
            var char1 = hex.charAt(0)
            var char2 = hex.charAt(1)
            var char3 = hex.charAt(2)
            hex = char1.concat(char1, char2, char2, char3, char3);
        }
        color.r = parseInt(hex.substring(0,2),16);
        color.g = parseInt(hex.substring(2,4),16);
        color.b = parseInt(hex.substring(4),16);
        
    };

    switch(data.constructor) {
        case IpcDataModel.ChipData:
            var family = IpcDataModel.ComponentAttribute.chipComponentFamily;

            if(data.componentFamily() === family["CAPACITOR"] || data.componentFamily() === family["POLARIZED_CAPACITOR"]) {
                color.r = 160;
                color.g = 135;
                color.b = 130;
            }

        break;

        case IpcDataModel.ChipArrayTwoSideFlatConcaveData:
        case IpcDataModel.ChipArrayFourSideFlatConcaveData:
            var family = IpcDataModel.ComponentAttribute.chipArrayComponentFamily.FLAT_CONCAVE;

            if(data.componentFamily() === family["CAPACITOR_NONPOLARIZED"]) {
                color.r = 160;
                color.g = 135;
                color.b = 130;
            }

        break;

        case IpcDataModel.ChipArrayTwoSideConvexData:
            var family = IpcDataModel.ComponentAttribute.chipArrayComponentFamily.TWO_SIDE_CONVEX;

            if(data.componentFamily() === family["CAPACITOR_NONPOLARIZED"]) {
                color.r = 160;
                color.g = 135;
                color.b = 130;
            }

        break;

        case IpcDataModel.MelfData:
            var family = IpcDataModel.ComponentAttribute.melfComponentFamily;

            if(data.componentFamily() === family["DIODE"]) {
                color.r = 167;
                color.g = 38;
                color.b = 12;
            }

        break;

        case IpcDataModel.AxialData:
            var family = IpcDataModel.PthComponentAttribute.type.AXIAL.family;

            if(data.componentFamily() === family["RESISTOR"]) {
                color.r = 222;
                color.g = 181;
                color.b = 127;
            } else if(data.componentFamily() === family["NONPOLARIZED_CAPACITOR"]) {
                color.r = 203;
                color.g = 196;
                color.b = 53;
            } else if(data.componentFamily() === family["POLARIZED_CAPACITOR"]) {
                color.r = 94;
                color.g = 208;
                color.b = 254;
            } else if(data.componentFamily() === family["DIODE"] || data.componentFamily() === family["INDUCTOR"]) {
                color.r = 30;
                color.g = 30;
                color.b = 30;
            } else if(data.componentFamily() === family["FUSE"]) {
                color.r = 200;
                color.g = 200;
                color.b = 200;
            }

        break;

        case IpcDataModel.RadialRoundData:
            hex = data.bodyColor();
            convertColor(hex);

        case IpcDataModel.ChipLedData:
        case IpcDataModel.RadialLedRoundData:
            hex = data.bodyColor() ? data.bodyColor() : data.customBodyColor()
            convertColor(hex);

        break;

    }

    return color;
};

IpcPackageParamHelper.getHeaderPackageOriginLocationId = function(data) {
    var id;

    if(data.footprintOriginLocation() === IpcDataModel.PthComponentAttribute.type.HEADER.footprintOriginLocation["CENTER_PADS"]) {
        id = 4;
    } else {
        id = IpcDataModel.PthComponentAttribute.type.HEADER.pinNumberSequencePattern[data.pinNumberSequencePattern()].pinOnePositionId;
    }

    return id;
};

IpcPackageParamHelper.isPolarized = function(data) {
    console.assert(data);

    switch(data.constructor) {
        case IpcDataModel.MoldedBodyData:
            var family = IpcDataModel.ComponentAttribute.moldedBodyComponentFamily;

            return data.componentFamily() === family["POLARIZED_CAPACITOR"]
            || data.componentFamily() === family["POLARIZED_DIODE"]
            || data.componentFamily() === family["LED"];

        break;

        case IpcDataModel.AxialData:
            return data.componentFamily() === IpcDataModel.PthComponentAttribute.type.AXIAL.family["DIODE"];
        break;

        case IpcDataModel.RadialRoundData:
            return data.componentFamily() === IpcDataModel.PthComponentAttribute.type.RADIALROUND.family["POLARIZED_CAPACITOR"]
            || data.componentFamily() === IpcDataModel.PthComponentAttribute.type.RADIALROUND.family["POLARIZED_INDUCTOR"];
        break;

        case IpcDataModel.MelfData:
            return data.componentFamily() === IpcDataModel.ComponentAttribute.melfComponentFamily["DIODE"];
        break;

        default:
            return false;
    }
};

IpcPackageParamHelper.isChipArrayLeadShapeFlat = function(data) {
    return data.leadShapeType() === IpcDataModel.ComponentAttribute.chipArrayLeadShapeType["FLAT"];
};

IpcPackageParamHelper.isChipLedWithRoundLens = function(data) {
    return data.lensType() === IpcDataModel.ComponentAttribute.chipLedLensType["RECT_DOMED_TOP"];
};

IpcPackageParamHelper.getParamsForPackage = function(data, unit) {
    var params = {};

    if(!data) return params;

    function convert(value) {
        var targetUnit = unit || 'millimeter';
        var dataUnit = 'um';
        return UnitConversions.convert(dataUnit, targetUnit, value);
    }

    function setOptionalParams() {
        //optional params send only D2 and L for 3D model
        if (data.optionalDimension() === IpcDataModel.ComponentAttribute.optionalDimensionInput["Optional_D"]){
            params['L'] = convert(data.padWidthMax()); 
            params['D2'] = convert(data.terminalGapMax());     
        } else if (data.optionalDimension() === IpcDataModel.ComponentAttribute.optionalDimensionInput["Optional_D2"]){
            params['L'] = convert(data.padWidthMax()); 
            params['D2'] = convert(data.horizontalLeadToLeadSpanMax() - data.padWidthMax() * 2);    
        } else if (data.optionalDimension() === IpcDataModel.ComponentAttribute.optionalDimensionInput["Optional_L"]){
            params['L'] = convert((data.horizontalLeadToLeadSpanMax() - data.terminalGapMax()) / 2); 
            params['D2'] = convert(data.terminalGapMax());    
        }
    };

    switch(data.constructor) {
        case IpcDataModel.SoicSopData:
        case IpcDataModel.CfpData:
        case IpcDataModel.Sot23Data:
        case IpcDataModel.SotflData:
            params['A'] = convert(data.bodyHeightMax());
            params['E1'] = convert(data.bodyWidthMax());
            params['D'] = convert(data.bodyLengthMax());
            params['A1'] = convert(data.bodyOffsetMin());
            params['b'] = convert(data.padHeightMax());
            params['E'] = convert(data.horizontalLeadToLeadSpanMax());
            params['e'] = convert(data.verticalPinPitch());
            params['L'] = convert((data.padWidthMax() + data.padWidthMin()) / 2);
            params['DPins'] = data.horizontalPadCount();

            if(data.hasThermalPad && data.hasThermalPad()) {
                params['thermal'] = 1;
                params['E2'] = convert(data.thermalPadLength());
                params['D2'] = convert(data.thermalPadWidth());
            }
        break;

        case IpcDataModel.CqfpData:
        case IpcDataModel.QfpData:
            params['A'] = convert(data.bodyHeightMax());
            params['E1'] = convert(data.bodyWidthMax());
            params['D1'] = convert(data.bodyLengthMax());
            params['A1'] = convert(data.bodyOffsetMin());
            params['b'] = convert(data.padHeightMax());
            params['D'] = convert(data.verticalLeadToLeadSpanMax());
            params['E'] = convert(data.horizontalLeadToLeadSpanMax());
            params['e'] = convert(data.verticalPinPitch());
            params['L'] = convert((data.padWidthMax() + data.padWidthMin()) / 2);
            params['DPins'] = data.horizontalPadCount() * 2;
            params['EPins'] = data.verticalPadCount() * 2;

            if(data.hasThermalPad()) {
                params['thermal'] = 1;
                params['E2'] = convert(data.thermalPadLength());
                params['D2'] = convert(data.thermalPadWidth());
            }

        break;

        case IpcDataModel.QfnData:
            params['A'] = convert(data.bodyHeightMax());
            params['b'] = convert(data.padHeightMax());
            params['D'] = convert(data.bodyWidthMax()); //for 3d model generation D and E are swapped
            params['E'] = convert(data.bodyLengthMax());
            params['e'] = convert(data.verticalPinPitch());
            params['L'] = convert((data.padWidthMax() + data.padWidthMin()) / 2);
            params['DPins'] = data.verticalPadCount() * 2;
            params['EPins'] = data.horizontalPadCount() * 2;

            if(data.hasThermalPad()) {
                params['thermal'] = 1;
                params['D1'] = convert(data.thermalPadLength());
                params['E1'] = convert(data.thermalPadWidth());
            }
        break;

        case IpcDataModel.ChipData:
            params['A'] = convert(data.bodyHeightMax());
            params['D'] = convert(data.bodyWidthMax());
            params['E'] = convert(data.bodyLengthMax());
            params['L'] = convert(data.padWidthMax());
            params['L1'] = convert(data.oddPadWidthMax());

            //body color
            var color = this.getBodyColor(data);
            params['color_r'] = color.r;
            params['color_g'] = color.g;
            params['color_b'] = color.b;
        break;

        case IpcDataModel.ChipArrayTwoSideConvexData:
            params['A'] = convert(data.bodyHeightMax());
            params['D'] = convert(data.bodyLengthMax());
            params['b'] = convert(data.padHeightMax());
            params['b1'] = convert(data.oddPadHeightMax());
            params['E'] = convert(data.bodyWidthMax());
            params['e'] = convert(data.verticalPinPitch());
            params['L'] = convert(data.padWidthMax());
            params['DPins'] = data.horizontalPadCount();

            //body color
            var color = this.getBodyColor(data);
            params['color_r'] = color.r;
            params['color_g'] = color.g;
            params['color_b'] = color.b;
        break;

        case IpcDataModel.ChipArrayTwoSideFlatConcaveData:
            params['A'] = convert(data.bodyHeightMax());
            params['D'] = convert(data.bodyLengthMax());
            params['b'] = convert(data.padHeightMax());
            params['E'] = convert(data.bodyWidthMax());
            params['e'] = convert(data.verticalPinPitch());
            params['L'] = convert(data.padWidthMax());
            params['DPins'] = data.horizontalPadCount();

            //body color
            var color = this.getBodyColor(data);
            params['color_r'] = color.r;
            params['color_g'] = color.g;
            params['color_b'] = color.b;

            if(this.isChipArrayLeadShapeFlat(data)) {
                params['isFlatLead'] = 1;
            } else {
                params['isFlatLead'] = 0;
            }
        break;

        case IpcDataModel.ChipArrayFourSideFlatConcaveData:
            params['A'] = convert(data.bodyHeightMax());
            params['D'] = convert(data.bodyLengthMax());
            params['b'] = convert(data.padHeightMax());
            params['b1'] = convert(data.oddPadHeightMax());
            params['E'] = convert(data.bodyWidthMax());
            params['e'] = convert(data.verticalPinPitch());
            params['L'] = convert(data.padWidthMax());
            params['L1'] = convert(data.oddPadWidthMax());
            params['N'] = data.horizontalPadCount();

            //body color
            var color = this.getBodyColor(data);
            params['color_r'] = color.r;
            params['color_g'] = color.g;
            params['color_b'] = color.b;

            if(this.isChipArrayLeadShapeFlat(data)) {
                params['isFlatLead'] = 1;
            } else {
                params['isFlatLead'] = 0;
            }
        break;

        case IpcDataModel.CrystalData:
            params['A'] = convert(data.bodyHeightMax());
            params['E'] = convert(data.bodyLengthMax());
            params['D1'] = convert(data.bodyWidthMax());
            params['b'] = convert(data.padHeightMax());
           setOptionalParams();
        break;

        case IpcDataModel.AluminumElectrolyticData:
            params['A'] = convert(data.bodyHeightMax());
            params['D1'] = convert(data.bodyWidthMax());
            params['b'] = convert(data.padHeightMax());
            setOptionalParams();
        break;

        case IpcDataModel.Dfn2Data:
            params['A'] = convert(data.bodyHeightMax());
            params['e'] = convert(data.horizontalPinPitch());
            params['b'] = convert(data.padHeightMax());
            params['L'] = convert(data.padWidthMax());
            params['D'] = convert(data.bodyWidthMax());
            params['E'] = convert(data.bodyLengthMax());
        break;

        case IpcDataModel.Dfn3Data:
            params['A'] = convert(data.bodyHeightMax());
            params['e'] = convert(data.verticalPinPitch());
            params['d'] = convert(data.horizontalPinPitch());
            params['b'] = convert(data.padHeightMax());
            params['b1'] = convert(data.oddPadWidthMax());
            params['L'] = convert(data.padWidthMax());
            params['L1'] = convert(data.oddPadHeightMax());
            params['D'] = convert(data.bodyWidthMax());
            params['E'] = convert(data.bodyLengthMax());
        break;

        case IpcDataModel.Dfn4Data:
            params['A'] = convert(data.bodyHeightMax());
            params['E'] = convert(data.bodyLengthMax());
            params['D'] = convert(data.bodyWidthMax());
            params['e'] = convert(data.verticalPinPitch());
            params['d'] = convert(data.horizontalPinPitch());
            params['b'] = convert(data.padHeightMax());
            params['L'] = convert(data.padWidthMax());
        break;

        case IpcDataModel.MelfData:
            params['E'] = convert(data.bodyLengthMax());
            params['D'] = convert(data.bodyWidthMax());
            params['L'] = convert(data.padWidthMax());

            //body color
            var color = this.getBodyColor(data);
            params['color_r'] = color.r;
            params['color_g'] = color.g;
            params['color_b'] = color.b;

            if(IpcPackageParamHelper.isPolarized(data)) params['isPolarized'] = 1;
        break;

        case IpcDataModel.MoldedBodyData:
            params['A'] = convert(data.bodyHeightMax());
            params['b'] = convert(data.padHeightMax());
            params['b1'] = convert(data.oddPadHeightMax());
            params['L'] = convert(data.padWidthMax());
            params['L1'] = convert(data.oddPadWidthMax());
            params['D'] = convert(data.bodyWidthMax());
            params['E'] = convert(data.bodyLengthMax());

            if(IpcPackageParamHelper.isPolarized(data)) params['isPolarized'] = 1;
        break;

        case IpcDataModel.OscillatorCornerConcaveData:
            params['A'] = convert(data.bodyHeightMax());
            params['D'] = convert(data.bodyWidthMax());
            params['E'] = convert(data.bodyLengthMax());
            params['D1'] = convert(data.horizontalTerminalGapMax());
            params['E1'] = convert(data.verticalTerminalGapMax());
        break;

        case IpcDataModel.OscillatorJLeadData:
            params['A'] = convert(data.bodyHeightMax());
            params['A1'] = convert(data.bodyOffsetMin());
            params['b'] = convert(data.padHeightMax());
            params['D'] = convert(data.bodyLengthMax());
            params['E'] = convert(data.horizontalLeadToLeadSpanMax());
            params['E1'] = convert(data.bodyWidthMax());
            params['E2'] = convert(data.terminalCenterToCenterDistance());
            params['e'] = convert(data.verticalPinPitch());
            params['DPins'] = data.horizontalPadCount();
        break;

        case IpcDataModel.OscillatorLBendData:
            params['A'] = convert(data.bodyHeightMax());
            params['b'] = convert(data.padHeightMax());
            params['D'] = convert(data.bodyLengthMax());
            params['E'] = convert(data.horizontalLeadToLeadSpanMax());
            params['E1'] = convert(data.bodyWidthMax());
            params['E2'] = convert(data.terminalCenterToCenterDistance());
            params['e'] = convert(data.verticalPinPitch());
            params['DPins'] = data.horizontalPadCount();
        break;

        case IpcDataModel.PlccData:
            params['A'] = convert(data.bodyHeightMax());
            params['A1'] = convert(data.bodyOffsetMin());
            params['b'] = convert(data.padHeightMax());
            params['D'] = convert(data.horizontalLeadToLeadSpanMax());
            params['E'] = convert(data.verticalLeadToLeadSpanMax());
            params['E1'] = convert(data.bodyLengthMax());
            params['D1'] = convert(data.bodyWidthMax());
            params['D2'] = convert(data.terminalCenterToCenterDistance());
            params['E2'] = convert(data.terminalCenterToCenterDistance2());
            params['e'] = convert(data.verticalPinPitch());
            params['EPins'] = data.horizontalPadCount() * 2;
            params['DPins'] = data.verticalPadCount() * 2;
        break;

        case IpcDataModel.SodData:
            params['A'] = convert(data.bodyHeightMax());
            params['A1'] = convert(data.bodyOffsetMin());
            params['b'] = convert(data.padHeightMax());
            params['D'] = convert(data.horizontalLeadToLeadSpanMax());
            params['E'] = convert(data.bodyLengthMax());
            params['D1'] = convert(data.bodyWidthMax());
            params['L'] = convert(data.padWidthMax());
        break;

        case IpcDataModel.SodflData:
            params['A'] = convert(data.bodyHeightMax());
            params['b'] = convert(data.padHeightMax());
            params['D'] = convert(data.horizontalLeadToLeadSpanMax());
            params['E'] = convert(data.bodyLengthMax());
            params['D1'] = convert(data.bodyWidthMax());
            params['L'] = convert(data.padWidthMax());
            params['b1'] = convert(data.oddPadHeightMax());
            params['L1'] = convert(data.oddPadWidthMax());
        break;

        case IpcDataModel.SojData:
            params['A'] = convert(data.bodyHeightMax());
            params['A1'] = convert(data.bodyOffsetMin());
            params['b'] = convert(data.padHeightMax());
            params['e'] = convert(data.verticalPinPitch());
            params['D'] = convert(data.bodyLengthMax());
            params['E'] = convert(data.horizontalLeadToLeadSpanMax());
            params['E1'] = convert(data.bodyWidthMax());
            params['E2'] = convert(data.terminalCenterToCenterDistance());
            params['EPins'] = data.horizontalPadCount();
        break;

        case IpcDataModel.Sot223Data:
        case IpcDataModel.Sot143Data:
            params['A'] = convert(data.bodyHeightMax());
            params['E'] = convert(data.horizontalLeadToLeadSpanMax());
            params['L'] = convert((data.padWidthMax() + data.padWidthMin()) / 2);
            params['b'] = convert(data.padHeightMax());
            params['b1'] = convert(data.oddPadHeightMax());
            params['E1'] = convert(data.bodyWidthMax());
            params['D'] = convert(data.bodyLengthMax());
            params['e'] = convert(data.verticalPinPitch());
            params['DPins'] = data.horizontalPadCount();
            params['A1'] = convert(data.bodyOffsetMin());
        break;

        case IpcDataModel.ToDpakData:
            params['A'] = convert(data.bodyHeightMax());
            params['E'] = convert(data.horizontalLeadToLeadSpanMax());
            params['L'] = convert(data.padWidthMax());
            params['L1'] = convert(data.extendedEdgeWidth());
            params['b'] = convert(data.padHeightMax());
            params['b1'] = convert(data.oddPadHeightMax());
            params['E1'] = convert(data.bodyWidthMax());
            params['E2'] = convert(data.oddPadWidthMax());
            params['D'] = convert(data.bodyLengthMax());
            params['e'] = convert(data.verticalPinPitch());
            params['DPins'] = data.horizontalPadCount();
            params['A1'] = convert(data.bodyOffsetMin());
            params['truncatedFlag'] = (data.hasTruncatedPin() ? 1 : 0);
        break;

        case IpcDataModel.BgaData:
            params['A'] = convert(data.bodyHeightMax());
            params['b'] = convert(data.padWidthMax());
            params['E'] = convert(data.bodyWidthMax());
            params['D'] = convert(data.bodyLengthMax());
            params['d'] = convert(data.verticalPinPitch());
            params['e'] = convert(data.horizontalPinPitch());
            params['DPins'] = data.horizontalPadCount();
            params['EPins'] = data.verticalPadCount();
        break;

        case IpcDataModel.AxialData:
            params['A'] = convert(data.bodyHeightMax());
            params['D'] = convert(data.bodyWidthMax());
            params['E'] = convert(data.bodyLengthMax());
            params['b'] = convert(data.terminalWidth());

            var leadInfo = data.getLeadExtensionAndBendRadius();
            params['R'] = convert(leadInfo.radius);

            if (data.pitchOverride()) {
                params['e'] = convert(data.getPinPitch());
            } else {
                params['L1'] = convert(leadInfo.extension);
            }

            if(IpcPackageParamHelper.isPolarized(data)) {
                params['isPolarized'] = 1;
            }

            //body color
            var color = this.getBodyColor(data);
            params['color_r'] = color.r;
            params['color_g'] = color.g;
            params['color_b'] = color.b;
        break;

        case IpcDataModel.DipData:
            params['A'] = convert(data.bodyHeightMax());
            params['A1'] = convert(data.bodyOffset());
            params['D'] = convert(data.bodyLengthMax());
            params['E1'] = convert(data.bodyWidthMax());
            params['E'] = convert(data.leadSpan());
            params['b'] = convert(data.terminalWidth());
            params['L'] = convert(data.terminalLength());
            params['c'] = convert(data.terminalThickness());
            params['e'] = convert(data.verticalPinPitch());
            params['DPins'] = data.horizontalPadCount();
        break;

        case IpcDataModel.HeaderStraightData:
        case IpcDataModel.HeaderStraightSocketData:
            params['DPins'] = data.horizontalPadCount();
            params['EPins'] = data.verticalPadCount();
            params['b'] = convert(data.terminalWidth());
            params['L1'] = convert(data.terminalTailLength());
            params['L2'] = convert(data.terminalPostLength());
            params['D'] = convert(data.bodyLengthMax());
            params['E'] = convert(data.bodyWidthMax());
            params['L'] = convert(data.bodyHeightMax());
            params['e'] = convert(data.verticalPinPitch());
            params['d'] = convert(data.horizontalPinPitch());
            params['originLocationId'] = this.getHeaderPackageOriginLocationId(data);
        break;

        case IpcDataModel.HeaderRightAngleData:
        case IpcDataModel.HeaderRightAngleSocketData:
            params['DPins'] = data.horizontalPadCount();
            params['EPins'] = data.verticalPadCount();
            params['b'] = convert(data.terminalWidth());
            params['L1'] = convert(data.horizontalTerminalTailLength());
            params['D'] = convert(data.bodyLengthMax());
            params['L'] = convert(data.bodyWidthMax());
            params['E'] = convert(data.bodyHeightMax());
            params['e'] = convert(data.verticalPinPitch());
            params['d'] = convert(data.horizontalPinPitch());
            params['originLocationId'] = this.getHeaderPackageOriginLocationId(data);

            if(data.constructor === IpcDataModel.HeaderRightAngleData) {
                params['L2'] = convert(data.terminalPostLength());
                params['L3'] = convert(data.verticalTerminalTailLength());
            } else {
                params['L2'] = convert(data.verticalTerminalTailLength());
            }
        break;

        case IpcDataModel.SonData:
            params['A'] = convert(data.bodyHeightMax());
            params['b'] = convert(data.padHeightMax());
            params['E'] = convert(data.bodyWidthMax());
            params['D'] = convert(data.bodyLengthMax());
            params['e'] = convert(data.verticalPinPitch());
            params['L'] = convert(data.padWidthMax());
            params['DPins'] = data.horizontalPadCount();

            if(data.hasThermalPad()) {
                params['thermal'] = 1;
                params['E2'] = convert(data.thermalPadLength());
                params['D2'] = convert(data.thermalPadWidth());
            }
        break;

        case IpcDataModel.RadialRoundData:
            params['A'] = convert(data.bodyHeightMax());
            params['D'] = convert(data.bodyWidthMax());
            params['b'] = convert(data.terminalWidth());
            params['e'] = convert(data.verticalPinPitch());

            if(IpcPackageParamHelper.isPolarized(data)) {
                params['isPolarized'] = 1;
            }

            //body color
            var color = this.getBodyColor(data);
            params['color_r'] = color.r;
            params['color_g'] = color.g;
            params['color_b'] = color.b;
        break;

        case IpcDataModel.RadialLedRoundData:
            params['A'] = convert(data.bodyHeightMax());
            params['A1'] = convert(data.bodyOffset());
            params['D'] = convert(data.bodyWidthMax());
            params['b'] = convert(data.terminalWidth());
            params['c'] = convert(data.terminalThickness());
            params['e'] = convert(data.verticalPinPitch());

            if(data.leadShape() === IpcDataModel.PthComponentAttribute.leadShapes["Rectangle"]) {
                params['isRectangularTerminal'] = 1;
            } else {
                params['isRectangularTerminal'] = 0;
            }

            //body color
            var color = this.getBodyColor(data);
            params['color_r'] = color.r;
            params['color_g'] = color.g;
            params['color_b'] = color.b;
        break;

        case IpcDataModel.CrystalHC49Data:
            params['A'] = convert(data.bodyHeightMax());
            params['E'] = convert(data.bodyLengthMax());
            params['D'] = convert(data.bodyWidthMax());
            params['b'] = convert(data.terminalWidth());
            params['e'] = convert(data.verticalPinPitch());
        break;

        case IpcDataModel.FemaleStandoffSpacerData:
            params['A'] = convert(data.bodyHeightMax());
            params['E'] = convert(data.bodyWidthMax());

            if (data.hasThread()) {
                params['thread'] = 1;

                params['threadType'] = data.threadType();
                params['threadDesignation'] = data.threadDesignation();
                
                if (data.hasPartialThread()) {
                    params['partial'] = 1;
                    params['L'] = convert(data.threadDepth());
                } else {
                    params['partial'] = 0;
                }
            } else {
                params['thread'] = 0;

                params['b'] = convert(data.holeDiameter());
            }

            params['body'] = data.bodyShape().toLowerCase();
        break;

        case IpcDataModel.MaleFemaleStandoffSpacerData:
            params['A'] = convert(data.bodyHeightMax());
            params['E'] = convert(data.bodyWidthMax());
            params['L'] = convert(data.innerThreadDepth());
            params['L1'] = convert(data.postLength());
            params['body'] = data.bodyShape().toLowerCase();

            params['innerThreadType'] = data.innerThreadType();
            params['innerThreadDesignation'] = data.innerThreadDesignation();

            params['postThreadType'] = data.postThreadType();
            params['postThreadDesignation'] = data.postThreadDesignation();
        break;

        case IpcDataModel.SnapLockData:
            params['A'] = convert(data.bodyHeightMax());
            params['A1'] = convert(data.boardThickness());
            params['L1'] = convert(data.lockHeightMax());
            params['E'] = convert(data.bodyWidthMax());
            params['E1'] = convert(data.getLockWidth());
            params['H'] = convert(data.holeDiameter());
        break;

        case IpcDataModel.ChipLedData:
            params['A'] = convert(data.bodyHeightMax());
            params['D'] = convert(data.bodyWidthMax());
            params['E'] = convert(data.bodyLengthMax());
            params['L'] = convert(data.padWidthMax());
            params['A1'] = convert(data.baseHeightMax());
            params['d'] = convert(data.domeDiameter());

            //body color
            var color = this.getBodyColor(data);
            params['color_r'] = color.r;
            params['color_g'] = color.g;
            params['color_b'] = color.b;

            if(this.isChipLedWithRoundLens(data)) {
                params['isRoundLens'] = 1;
            } else {
                params['isRoundLens'] = 0;
            }
            
        break;
            
    }

    return params;
};

module.exports = IpcPackageParamHelper;
